import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceAnalytics = ({ machines }) => {
  const totalPrintHours = machines?.reduce((sum, m) => sum + m?.totalPrintHours, 0);
  const averageUtilization = Math.round(
    machines?.reduce((sum, m) => sum + m?.utilizationRate, 0) / machines?.length
  );
  const averageSuccessRate = (
    machines?.reduce((sum, m) => sum + m?.successRate, 0) / machines?.length
  )?.toFixed(1);

  const topPerformers = [...machines]
    ?.sort((a, b) => b?.successRate - a?.successRate)
    ?.slice(0, 3);

  const lowPerformers = [...machines]
    ?.filter(m => m?.successRate < 95)
    ?.sort((a, b) => a?.successRate - b?.successRate)
    ?.slice(0, 3);

  return (
    <div className="bg-card border border-border rounded-lg p-5 mt-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Analyse de Performance</h2>
        <Icon name="BarChart3" size={20} className="text-muted-foreground" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="p-4 bg-primary/5 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Clock" size={18} className="text-primary" />
            <span className="text-sm text-muted-foreground">Heures totales</span>
          </div>
          <div className="text-2xl font-bold text-foreground">{totalPrintHours?.toLocaleString()}h</div>
        </div>

        <div className="p-4 bg-warning/5 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Activity" size={18} className="text-warning" />
            <span className="text-sm text-muted-foreground">Utilisation moyenne</span>
          </div>
          <div className="text-2xl font-bold text-foreground">{averageUtilization}%</div>
        </div>

        <div className="p-4 bg-success/5 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={18} className="text-success" />
            <span className="text-sm text-muted-foreground">Taux de réussite moyen</span>
          </div>
          <div className="text-2xl font-bold text-foreground">{averageSuccessRate}%</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
            <Icon name="TrendingUp" size={16} className="text-success" />
            Meilleures Performances
          </h3>
          <div className="space-y-2">
            {topPerformers?.map((machine, index) => (
              <div key={machine?.id} className="flex items-center justify-between p-3 bg-success/5 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center">
                    <span className="text-xs font-bold text-success">{index + 1}</span>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground">{machine?.name}</div>
                    <div className="text-xs text-muted-foreground">{machine?.model}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-semibold text-success">{machine?.successRate}%</div>
                  <div className="text-xs text-muted-foreground">{machine?.totalPrintHours}h</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {lowPerformers?.length > 0 && (
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="AlertTriangle" size={16} className="text-warning" />
              Nécessite Attention
            </h3>
            <div className="space-y-2">
              {lowPerformers?.map((machine) => (
                <div key={machine?.id} className="flex items-center justify-between p-3 bg-warning/5 rounded-lg">
                  <div>
                    <div className="text-sm font-medium text-foreground">{machine?.name}</div>
                    <div className="text-xs text-muted-foreground">{machine?.model}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold text-warning">{machine?.successRate}%</div>
                    <div className="text-xs text-muted-foreground">Sous la moyenne</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceAnalytics;